import Vue from 'vue';
import ShoppingWizardButton from './components/ShoppingWizardButton';
import ShoppingWizardModal from './components/ShoppingWizardModal';
import ShoppingWizardProperties from './components/ShoppingWizardProperties';
import ShoppingWizardSelectionButton from './components/ShoppingWizardSelectionButton';

// Install BootstrapVue

Vue.component('shopping-wizard-button', ShoppingWizardButton);
Vue.component('shopping-wizard-modal', ShoppingWizardModal);
Vue.component('shopping-wizard-properties', ShoppingWizardProperties);
Vue.component('shopping-wizard-selection-button', ShoppingWizardSelectionButton);




// WEBPACK FOOTER //
// ./src/main.js